import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    supportData,
    enterVoiceover,
  },
} = checkout;

const validation2 = Yup.object().shape({
  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),
  [taxAgentName.name]: Yup.string().optional(),
  [taxAgentCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentCode.invalidMsg)
    .optional(),
  [supportData.name]: Yup.string().required(supportData.errorMsg),
  [enterVoiceover.name]: Yup.string().required(enterVoiceover.errorMsg),
});

export default validation2;
